module.exports = __webpack_public_path__ + "aac937bfcbd009cdf13a6d5acecd578f.png";